export function getRequestAccessToken(data: unknown): string | null {
  if (typeof data === 'string') {
    try {
      return getRequestAccessToken(JSON.parse(data));
    } catch {
      return null;
    }
  }

  if (typeof data !== 'object' || data === null || !('token' in data)) {
    return null;
  }

  const token = (data as { token?: unknown }).token;
  return typeof token === 'string' ? token : null;
}

export function shouldEndSessionOnUnauthorized(accessToken: string | null, requestData: unknown): boolean {
  if (!accessToken) {
    return false;
  }

  return getRequestAccessToken(requestData) === accessToken;
}
